import { Minus, Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';

const SelectQuantity = ({ quantity, setQuantity }) => {
  const increment = () => {
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <div className="flex items-center justify-center w-full max-w-[200px] mx-auto">
      <Button
        variant="outline"
        size="icon"
        onClick={decrement}
        disabled={quantity <= 1}
        aria-label="Decrease quantity"
        className="h-10 w-10 rounded-full"
      >
        <Minus className="h-4 w-4" />
      </Button>
      <div className="w-16 text-center font-medium text-lg mx-2">
        {quantity}
      </div>
      <Button
        variant="outline"
        size="icon"
        onClick={increment}
        aria-label="Increase quantity"
        className="h-10 w-10 rounded-full"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SelectQuantity;
